<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="mx-auto" flat>
        <confirmation-header-text :text="$vuetify.lang.t('$vuetify.organization_detail')" class="ml-0"
                                  icon="business"></confirmation-header-text>
        <v-card-text class="pt-3 pb-0">
          <v-layout row>
            <v-flex md4 xs12>
              <v-autocomplete
                  :items="companies"
                  :rules="[rules.required]"
                  class="pr-2"
                  item-text="name"
                  item-value="name"
                  :label="$vuetify.lang.t('$vuetify.select_organization_name') + ' *'"
                  outlined
                  v-model="visa.extra.application_data.organization_name">
              </v-autocomplete>

            </v-flex>
            <v-flex xs12 sm4 v-if="visa.extra.application_data.organization_name === 'Others'">
              <v-text-field
                  :label="$vuetify.lang.t('$vuetify.organization_name')+'*'"
                  outlined
                  type="text"
                  :rules="[rules.required]"
                  v-model="visa.extra.application_data.other_organization_name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 class="pl-2">
              <address-auto-complete
                  :label="$vuetify.lang.t('$vuetify.address_of_organization') +'*'"
                  v-model="visa.extra.application_data.address_of_business_institute"
                  country-code="np"
                  :rules="[rules.required]"
              ></address-auto-complete>
            </v-flex>
            <v-flex xs12 sm4 class="pl-2">
              <v-text-field
                  :label="$vuetify.lang.t('$vuetify.position')+'*'"
                  outlined
                  type="text"
                  :rules="[rules.required]"
                  v-model="visa.extra.application_data.position"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import AddressAutoComplete from "../../AddressAutoComplete";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";
import {validationMixin} from "../../../mixins/validationMixin";
import {fetchDynamicValues} from "../../../helpers/dynamicValueHelper";

export default {
  data: () => ({
    addressLoading: false,
    companies: []
  }),
  mixins: [validationMixin],
  components: {
    "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
  },
  computed: {
    visa() {
      return this.$store.state.VisaSingle.visa;
    }
  },
  mounted() {
    fetchDynamicValues('Company').then((res) => {
      this.companies = res;
    })
  }
}
</script>
